import { BaseComponent } from '../../../../components/BaseComponent';
import { HBox, VBox } from '../../../../components/Box';
import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { emailInvoice } from '../../actions';
import { selectWork } from '../../../Api/selectors';
import { EditSquare } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';
import { WithCompany } from '../../../Companies/components/WithCompany';
import { selectCompany } from '../../../Companies/selectors';
import { CompanyLabel } from '../../../Companies/components/CompanyLabel';
import { UserLabelById } from '../../../Users/components/UserLabelById';
import { UserSelection } from '../../../Users/components/UserSelection';
import { VehicleCreateFieldCompanyUser } from '../../../Vehicles/pages/create/FieldCompanyUser';
import { getPropByName } from '../../../../utils/props';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Checkbox } from '../../../../components/Checkbox';
import { Well } from '../../../../components/Well';
import { fetchUser } from '../../../Users/actions';
import { selectUser } from '../../../Users/selectors';
import { INVOICE_DIRECTIONS, REQUEST_INVOICE_EMAIL } from '../../constants';
import { REQUEST_COMPANY } from '../../../Companies/constants';

const ButtonWrapper = styled.div`
  position: ${props => (props.topButton ? 'absolute' : '')};
  top: 0;
  right: 0;
  & > .button {
    margin: 6px 0;
  }
`;

const STATE = {
  email: false,
  target_email_address: '',
  target_email_address_set: false,
  financialContact: null,
  emailContact: null,
  emailTo: '',
};

class SendToEmailModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.financialContactId &&
      this.props.fetchUser(this.props.financialContactId, res => {
        if (res?.id) {
          this.setState({
            financialContact: res,
            isShow_financialContact: '1',
          });
        }
      });
    this.props.emailContactId &&
      this.props.fetchUser(this.props.emailContactId, res => {
        if (res?.id) {
          this.setState({
            emailContact: res,
            isShow_emailContact: '1',
          });
        }
      });
    this.props.invoice?.emailTo &&
      this.setState({
        emailTo: this.props.invoice?.emailTo,
        isShow_emailTo: '1',
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.financialContactId && !this.state.financialContact) {
      this.props.fetchUser(this.props.financialContactId, res => {
        if (res?.id) {
          this.setState({
            financialContact: res,
            isShow_financialContact: '1',
          });
        }
      });
    }

    if (this.props.emailContactId && !this.state.emailContact) {
      this.props.fetchUser(this.props.emailContactId, res => {
        if (res?.id) {
          this.setState({
            emailContact: res,
            isShow_emailContact: '1',
          });
        }
      });
    }

    if (this.props.invoice?.emailTo && !this.state.emailTo) {
      this.setState({
        emailTo: this.props.invoice?.emailTo,
        isShow_emailTo: '1',
      });
    }
  }

  get invoiceId() {
    return this.props.invoice?.id;
  }

  get userCreatorEmail() {
    return this.props.user?.email_address;
  }

  get financialContact() {
    return this.props.financialContactId?.email_address;
  }

  get outgoingUser() {
    return this.props.outgoingUserId?.email_address;
  }

  get emailContact() {
    return this.props.emailContactId?.email_address;
  }

  get emailTo() {
    return this.props.invoice?.emailTo;
  }

  get selectedEmails() {
    let emails = [];
    ['financialContact', 'emailContact', 'emailTo'].map(type => {
      if (type === 'emailTo' && this.state.emailTo && this.state[`isShow_${type}`] == '1') {
        return emails.push({ email: this.state.emailTo });
      }
      if (this.state[type]?.email_address && this.state[`isShow_${type}`] == '1') {
        emails.push({ email: this.state[type]?.email_address });
      }
    });

    return emails;
  }

  onChangeUser(userId, type) {
    this.props.fetchUser(userId, result => {
      if (result?.id) {
        this.setState({ [type]: result, selectUser: false, addUser: null });
      }
    });
  }

  renderAddUser() {
    if (!this.state.selectUser) return null;
    return (
      <Modal title={this.lbl('company.users.delete.confirm.title')}>
        {this.state.addUser?.id ? (
          <VBox>{this.state.addUser?.email_address}</VBox>
        ) : (
          <UserSelection onSelect={user => this.setState({ addUser: user })} />
        )}
        <ModalControls>
          <Button
            disabled={!this.state.addUser?.id}
            onClick={() => this.onChangeUser(this.state.addUser?.id, 'emailContact')}
          >
            {this.lbl('add')}
          </Button>
          <Button onClick={() => this.setState({ selectUser: false, addUser: null })}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.target_email_address_set && state.target_email_address == STATE.target_email_address && props.targetCompany) {
      //email should be sent to mail address
      state.target_email_address_set = true;
      let invoice_to_main_address = getPropByName(props.targetCompany, 'invoice_to_main_address');
      if (invoice_to_main_address === '1') state.target_email_address = getPropByName(props.targetCompany, 'company_email');
      else {
        //email goes to financial contact
        let financial_contact = props.targetCompany.users?.find(
          user => user.id == getPropByName(props.targetCompany, 'relation_financial_contact_id'),
        );

        if (financial_contact) {
          //finacial contact is found
          state.target_email_address = getPropByName(financial_contact, 'email_address');
        }
      }
    }
    return state;
  }

  render() {
    return this.renderEmailModal();
  }

  renderEmailModal() {
    if (this.props.invoice?.direction === INVOICE_DIRECTIONS.INCOMING && (this.props.busy || this.props.sending))
      return <Loader />;
    const targetCompanyId =
      this.props.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING
        ? this.props.invoice?.outgoingCompanyId
        : this.props.invoice?.incomingCompanyId;

    if (!targetCompanyId) return <Well alert>{this.lbl('invoice.item.warning.no_target_company')}</Well>;

    return (
      <div style={{ color: 'black' }}>
        <WithCompany companyId={targetCompanyId} loader>
          <Well>
            <CompanyLabel company={this.props.targetCompany} />
          </Well>
          {this.renderAddUser()}
          {this.props.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING && (
            <>
              {['financialContact', 'emailContact'].map(type => {
                if (type == 'emailContact' && this.state) {
                  return (
                    <HBox key={type} left vCenter style={{ marginBottom: '15px' }}>
                      <Checkbox
                        checked={this.state[`isShow_${type}`] === '1'}
                        onChange={() => {
                          this.state[`isShow_${type}`] == '1'
                            ? this.setState({ [`isShow_${type}`]: '0' })
                            : this.setState({ [`isShow_${type}`]: '1' });
                        }}
                      />

                      <VBox>
                        <span style={{ marginBottom: '5px', fontWeight: '400' }}>
                          {this.lbl(`vehicle.order.property.send_to_email`)}
                        </span>

                        <div style={{ display: 'flex', marginBottom: '24px ' }}>
                          <UserLabelById order user_id={this.state.emailContact?.id} key={this.state.emailContact?.id} />
                          <Button
                            disabled={this.state[`isShow_${type}`] !== '1'}
                            small
                            onClick={() => this.setState({ selectUser: true })}
                          >
                            <EditSquare />
                          </Button>
                        </div>
                      </VBox>
                    </HBox>
                  );
                }
                return (
                  this.state[type] && (
                    <HBox key={type} style={{ marginBottom: '15px' }}>
                      <FormField label={this.lbl('vehicle.order.property.financial_contact')}>
                        <Checkbox
                          checked={this.state[`isShow_${type}`] === '1'}
                          onChange={() => {
                            this.state[`isShow_${type}`] == '1'
                              ? this.setState({ [`isShow_${type}`]: '0' })
                              : this.setState({ [`isShow_${type}`]: '1' });
                          }}
                        ></Checkbox>
                        <VehicleCreateFieldCompanyUser
                          financialContact={true}
                          includeFinancialContact={this.state[`isShow_${type}`] === '1' ? '1' : '0'}
                          selectedCreditorId={this.state.financialContact?.id}
                          title={type}
                          companyId={targetCompanyId}
                          key={`${type}-${targetCompanyId}`}
                          type={type}
                          onChange={value => this.onChangeUser(value, type)}
                        />
                      </FormField>
                    </HBox>
                  )
                );
              })}
              <HBox left>
                <Checkbox
                  checked={this.state['isShow_emailTo'] === '1'}
                  onChange={evt =>
                    this.state['isShow_emailTo'] == '1'
                      ? this.setState({ ['isShow_emailTo']: '0' })
                      : this.setState({ ['isShow_emailTo']: '1' })
                  }
                />
                <FormField>
                  <Input
                    disabled={this.state['isShow_emailTo'] != '1'}
                    type="email"
                    style={{ width: 'auto' }}
                    value={this.state.emailTo}
                    onChange={evt => {
                      this.setState({ emailTo: evt.target.value });
                    }}
                  />
                </FormField>
              </HBox>
            </>
          )}

          {this.props.invoice?.direction !== INVOICE_DIRECTIONS.OUTGOING && (
            <FormField label={this.lbl('invoice.item.target_email_address')}>
              <Input
                full
                name="target_email_address"
                onChange={this.onInputChange.bind(this)}
                value={this.state.target_email_address}
              />
            </FormField>
          )}
          {this.props.actionFunctionName == 'FIN_final_invoice_no_email' && (
            <ButtonWrapper topButton={this.props.topButton}>
              <Button
                primary
                disabled={
                  this.props.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING
                    ? !this.selectedEmails.length
                    : !this.state.target_email_address
                }
                onClick={() => {
                  this.props.email(this.selectedEmails, () => {
                    if (this.props.performAction) {
                      this.props.performAction();
                    }
                    this.reset();
                  });
                }}
              >
                {this.lbl('invoice.details.send_to_email')}
              </Button>
            </ButtonWrapper>
          )}
        </WithCompany>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    busy: selectWork(REQUEST_COMPANY),
    sending: selectWork(`${REQUEST_INVOICE_EMAIL}-${ownProps.invoice?.id}`),
    targetCompany: selectCompany(
      ownProps.invoice?.direction == INVOICE_DIRECTIONS.OUTGOING
        ? ownProps.invoice?.outgoingCompanyId
        : ownProps.invoice?.incomingCompanyId,
    ),
    user: selectUser(ownProps?.userCreatorId),
    financialContact: selectUser(ownProps?.financialContactId),
    outgoingUser: selectUser(ownProps?.outgoingUserId),
    emailContact: selectUser(ownProps?.emailContactId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchUser(id, callback) {
      dispatch(fetchUser(id, callback));
    },
    email(address, callback) {
      dispatch(emailInvoice(ownProps.invoice?.id, address, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SendToEmailModal = compose(withConnect, withRouter)(SendToEmailModalComp);
